import type { FC, PropsWithChildren } from "react"

import { Sheet, SheetOverlay } from "commons"
import { PracticeSettings } from "settings"

import fallbackBg from "images/ChartedHealth/background.webp"

const PatientOnboardingLayout: FC<PropsWithChildren<Props>> = ({ settings, children }) => {
  return (
    <Sheet>
      <SheetOverlay
        imageSrc={settings.appOrgChartBg ?? fallbackBg}
        fallbackImage={fallbackBg}
      />
      <div className="relative z-10 flex w-full max-w-[38rem] flex-col items-stretch gap-6 px-5 md:gap-8 md:px-0">
        {children}
      </div>
    </Sheet>
  )
}

type Props = {
  settings: PracticeSettings
}

export { PatientOnboardingLayout }
